import {
    AutocompleteInput,
    Button,
    Datagrid,
    FunctionField,
    ListProps,
    ReferenceInput,
    TextField,
    useNotify, useRefresh
} from "react-admin";
import {CustomList} from "../components/CustomList";
import {useOptionsResource} from "../shared/hooks/useOptionsResource";
import {initField, initInput} from "../shared/utils";

import {LuCloudUpload} from "react-icons/lu";
import {client} from "../dataProvider";
import {useState} from "react";
import {CircularProgress} from "@material-ui/core";
import {IdentifierField} from "../components/IdentifierField";

const ActionChatId = () => {
    const [loading, setLoading] = useState(false);
    const notify = useNotify();
    const refresh = useRefresh()
    const handleClick = async () => {
        setLoading(true);
        await client(
            "notification_chat_id/update_chat_ids_telegram_request",
            {method: "GET"}
        ).then((response) => {
            if (response["done"]){
                notify("Chat ID aggiornati con successo", "success")
                refresh()
            } else
                notify("Erroe", "error")
        }).catch(() => {
            notify("Errore", "error")
        }).finally(() => setLoading(false));
    }


    return (
        <Button label="Update chat id" color="primary" onClick={handleClick} disabled={loading}>
            {loading ? <CircularProgress size={18} thickness={2}/> : <LuCloudUpload/>}
        </Button>
    )
};


export const NotificationChatIdList = (props: ListProps) => {
    const {data: options} = useOptionsResource("GET");


    const filters = options ? [
        <ReferenceInput
            {...initField("user", options)}
            reference="autocomplete/user"
            label="Utente"
            alwaysOn
        >
            <AutocompleteInput optionText="label"/>
        </ReferenceInput>,

    ] : [];


    return options ? (
        <CustomList {...props} filters={filters} additionalActions={<ActionChatId/>}>
            <Datagrid>
                <IdentifierField {...initField("id", options)}/>
                <FunctionField source="user_object"
                               render={(record: any) => record.user_object ? `${record.user_object.id} ${record.user_object.username}` : ""}
                               label="Utente"/>
                <TextField source="chat_id" label="Chat ID"/>
                <TextField source="info" label="Info"/>
            </Datagrid>
        </CustomList>
    ) : null;
}